import { deleteKeysObject, ImplementationMissingException, removeDBObjectKeys, tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateNonMandatoryObject, tsValidateOptionalId, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { ActionSubTypes_Interflow, ActionSubTypes_Order, ActionType_Interflow, ActionType_Order } from './types.js';
import { orderTypes, resolutionTypes } from './consts.js';
import { pathwayAction_isInterflow, pathwayAction_isOrder } from './utils.js';
import { DBDef_Expression, knowledgeManagerDBGroup, Validator_TagGroup } from '@app/hcs-shared';
const Validator_Action_General = {
    //General
    name: tsValidateString(),
    label: tsValidateString(-1, false),
    expressionId: tsValidateOptionalId,
    properties: tsValidateDynamicObject(tsValidateUniqueId, tsValidateUniqueId, false),
    variableIds: tsValidateArray(tsValidateUniqueId),
    resolution: tsValidateValue([...resolutionTypes]),
    resolutionDialog: tsValidateNonMandatoryObject({
        clinicalFormKey: tsValidateString(),
        isOrderSpecific: tsValidateBoolean()
    }),
    resolutionFindings: tsValidateArray({ valueId: tsValidateUniqueId, variableId: tsValidateUniqueId }, false),
    metadata: tsValidateNonMandatoryObject({
        orderType: tsValidateValue([...orderTypes], false),
        disposition: tsValidateBoolean(false),
        inbox: tsValidateNonMandatoryObject({
            shouldNotAppear: tsValidateBoolean(false),
            canNurseResolve: tsValidateBoolean(false),
        }),
    }),
    tagGroups: tsValidateArray(Validator_TagGroup)
};
const Validator_Action_Order = {
    ...Validator_Action_General,
    //Type Specific
    type: tsValidateValue([ActionType_Order]),
    subType: tsValidateValue([...ActionSubTypes_Order]),
    relatedVariables: tsValidateArray(tsValidateUniqueId, false),
    snippetId: tsValidateOptionalId,
    variableId: tsValidateUniqueId,
    wizardId: tsValidateOptionalId,
    resourceId: tsValidateUniqueId,
    isOrderSet: tsValidateBoolean(),
};
const Validator_Action_Interflow = {
    //General
    ...Validator_Action_General,
    //Type Specific
    type: tsValidateValue([ActionType_Interflow]),
    subType: tsValidateValue([...ActionSubTypes_Interflow]),
};
const Validator_Action = (instance, parentObject) => {
    const __toValidate = deleteKeysObject(removeDBObjectKeys(instance), DBDef_Action.generatedProps);
    if (pathwayAction_isOrder(__toValidate))
        return tsValidateResult(__toValidate, Validator_Action_Order);
    if (pathwayAction_isInterflow(__toValidate))
        return tsValidateResult(__toValidate, Validator_Action_Interflow);
    throw new ImplementationMissingException(`Missing validator for action of type ${instance.type}`);
};
const Validator_GeneratedProps = {
    __resourceId: tsValidateOptionalId,
    __variableIds: tsValidateArray(tsValidateUniqueId),
    __valueIds: tsValidateArray(tsValidateUniqueId),
    _tagIds: tsValidateArray(tsValidateUniqueId)
};
/** Dependency wiring for actions; asserted because optional ref keys use a narrow `fieldType` union. */
const DBDef_Action_dependencies = {
    '__resourceId': {
        dbKey: 'resources',
        fieldType: 'string',
    },
    '__variableIds': {
        dbKey: 'variables',
        fieldType: 'string[]',
    },
    '__valueIds': {
        dbKey: 'values',
        fieldType: 'string[]',
    },
    'expressionId': {
        dbKey: DBDef_Expression.dbKey,
        fieldType: 'string',
    },
    'snippetId': { dbKey: 'advisor-context', fieldType: 'string' },
    'wizardId': { dbKey: 'advisor-wizard', fieldType: 'string' },
    '_tagIds': {
        dbKey: 'tags',
        fieldType: 'string[]',
    },
};
export const DBDef_Action = {
    modifiablePropsValidator: Validator_Action,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['__resourceId', '__variableIds', '__valueIds', '_tagIds'],
    versions: ['1.0.10', '1.0.9', '1.0.8', '1.0.7', '1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'orders',
    entityName: 'Action',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'action'
    },
    backend: {
        name: 'orders',
    },
    dependencies: DBDef_Action_dependencies,
};
//# sourceMappingURL=db-def.js.map